import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import LegacyPrivacy from '../../legal/LegacyPrivacy20250918';
import { LegalDocument } from '../../legal/LegalDocument';
import { LegalDocument as Document } from '../../legal/types';

/** Only an explicit no-replacement response selects the prior active notice. */
export default function Privacy() {
  const [document, setDocument] = useState<Document | null>(null);
  const [state, setState] = useState<
    'loading' | 'legacy' | 'approved' | 'error'
  >('loading');
  useEffect(() => {
    let active = true;
    fetch(`${process.env.REACT_APP_API_BASE_URL || ''}/api/privacy/policy/`, {
      credentials: 'omit',
      referrerPolicy: 'no-referrer',
    })
      .then(async (r) => {
        if (!active) return;
        if (r.status === 404) {
          setState('legacy');
          return;
        }
        if (!r.ok) throw new Error('Unavailable');
        const data = await r.json();
        if (!active) return;
        if (!data?.document?.content || !data?.effective_date)
          throw new Error('Incomplete response');
        setDocument(data.document);
        setState('approved');
      })
      .catch(() => {
        if (active) setState('error');
      });
    return () => {
      active = false;
    };
  }, []);
  if (state === 'loading')
    return (
      <p role="status" className="p-8">
        Loading Privacy Policy…
      </p>
    );
  if (state === 'error')
    return (
      <main className="p-8">
        <h1 className="text-2xl font-semibold">Privacy Policy</h1>
        <p role="alert">
          The current notice could not be loaded. Please reload to try again.
        </p>
        <Link className="underline" to="/legal/archive/privacy-2025-09-18">
          Read the archived September 18, 2025 policy
        </Link>
      </main>
    );
  return state === 'approved' && document ? (
    <LegalDocument document={document} />
  ) : (
    <LegacyPrivacy />
  );
}
